import { distinctUntilChanged, map } from 'rxjs/operators';
import { HumanPlaceholder } from 'atomicComponents/HumanPlaceholder/HumanPlaceholder';
import { EmptyWorkspaceProps } from './types';
import { dispatchAction, connect } from '@ardoq/rxbeach';
import { isPresentationMode } from 'env';
import { gridEditor$ } from 'gridEditor/gridEditor$';
import { gridEditorStateOperations as gridEditorStateOperations } from 'gridEditor/gridEditorStateOperations';
import { combineLatest } from 'rxjs';
import * as gridEditorActions from 'gridEditor/actions';
import { i18nLocale$ } from 'streams/i18nLocale$';
import { t, type WithI18nLocale } from '@ardoq/i18n';

const openGridEditor = () => {
  dispatchAction(gridEditorActions.showGridEditor());
};

type EmptyWorkspaceConnectedProps = EmptyWorkspaceProps & WithI18nLocale;

const EmptyWorkspaceBase = ({
  i18nLocale,
  ...props
}: EmptyWorkspaceConnectedProps) => {
  const noDataTitle = t(
    i18nLocale,
    'emptyWorkspace:noData.title',
    'There is no data to show'
  );
  if (isPresentationMode()) {
    return (
      <HumanPlaceholder
        title={noDataTitle}
        subtitle={t(
          i18nLocale,
          'emptyWorkspace:noData.presentationModeSubtitle',
          'Data can be added through the main Ardoq application.'
        )}
      />
    );
  }
  const openGridEditorButton = {
    label: 'Open Grid Editor',
    isPrimary: true,
    onClick: openGridEditor,
  };
  const actions = props.gridVisible ? [] : [openGridEditorButton];
  const subtitle =
    props.subtitle ??
    `Data can easily be added through the Grid Editor ${
      props.gridVisible ? 'below' : ''
    }`;

  return (
    <HumanPlaceholder
      title={noDataTitle}
      subtitle={subtitle}
      actions={actions}
      {...props}
    />
  );
};

export const EmptyWorkspace = connect(
  EmptyWorkspaceBase,
  combineLatest({
    gridVisible: gridEditor$.pipe(
      map(gridEditor => {
        return (
          gridEditorStateOperations.isDockedGridEditorState(gridEditor) &&
          gridEditorStateOperations.isDockedGridEditorOpen(gridEditor)
        );
      }),
      distinctUntilChanged()
    ),
    i18nLocale: i18nLocale$,
  })
);
